import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import { TCalendarDate } from "../../../../components/commons/ono-calendar-v2/calendar_types";

export type TPayoutFilters = {
  selectedTypes: string[];
  selectedStatuses: string[];
  selectedCustomers: string[];
};

export type TCustomerInfo = {
  customerName: string;
  benCode: string;
};

type TinitialState = {
  calendarDate: TCalendarDate;
  payouts: TPayoutInfo[];
  selectedPayoutId: string;
  filters: TPayoutFilters;
  customers: TCustomerInfo[];
};

export type TPayoutInfo = {
  utr: string;
  createdOn: string;
  type: string;
  receiver: string;
  amount: number;
  payoutId: string;
  status: string;
  benCode: string;
  prodId: string;
};

const initialState: TinitialState = {
  calendarDate: {
    fromDate: moment().startOf("month").format("YYYY-MM-DD"),
    toDate: moment().endOf("month").format("YYYY-MM-DD"),
    mode: "MONTHLY",
  },
  payouts: [],
  selectedPayoutId: "",
  filters: {
    selectedTypes: [],
    selectedStatuses: [],
    selectedCustomers: [],
  },
  customers: [],
};

const payoutsSlice = createSlice({
  name: "payouts",
  initialState: initialState,
  reducers: {
    setPayouts: (
      state,
      action: PayloadAction<{
        payouts: TPayoutInfo[];
      }>,
    ) => {
      state.payouts = action.payload.payouts;
    },
    setCustomers: (
      state,
      action: PayloadAction<{
        customers: TCustomerInfo[];
      }>,
    ) => {
      state.customers = action.payload.customers;
    },
    setCalendarDate: (
      state,
      action: PayloadAction<{
        calendarDate: TCalendarDate;
      }>,
    ) => {
      state.calendarDate = action.payload.calendarDate;
    },
    setPayoutId: (
      state,
      action: PayloadAction<{
        payoutId: string;
      }>,
    ) => {
      state.selectedPayoutId = action.payload.payoutId;
    },
    setSelectedFilters: (
      state,
      action: PayloadAction<{
        selectedTypes: string[];
        selectedStatuses: string[];
        selectedCustomers: string[];
      }>,
    ) => {
      state.filters.selectedTypes = action.payload.selectedTypes;
      state.filters.selectedStatuses = action.payload.selectedStatuses;
      state.filters.selectedCustomers = action.payload.selectedCustomers;
    },
  },
});

export const {
  setPayouts,
  setCustomers,
  setCalendarDate,
  setPayoutId,
  setSelectedFilters,
} = payoutsSlice.actions;
export default payoutsSlice.reducer;
